import React from "react";

function CautionIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M6.56251 0.53833C6.68829 0.53833 6.81407 0.565674 6.92892 0.617627L12.0777 2.80239C12.6793 3.05669 13.1277 3.65005 13.125 4.36646C13.1113 7.07896 11.9957 12.0418 7.28439 14.2977C6.82775 14.5165 6.29728 14.5165 5.84064 14.2977C1.12931 12.0418 0.0136843 7.07896 1.24373e-05 4.36646C-0.00272194 3.65005 0.445716 3.05669 1.04728 2.80239L6.19884 0.617627C6.31095 0.565674 6.43673 0.53833 6.56251 0.53833ZM6.56251 2.36489V12.7008C10.3359 10.8743 11.3504 6.83013 11.375 4.40474L6.56251 2.36489Z"
        fill="#28A745"
      />
    </svg>
  );
}

export default CautionIcon2;
